import { Box } from "@mui/material";
import { styled } from "@mui/system";

const LeftGridTemplateStyles = styled(Box)(({ theme }) => ({
  "& .leftGridCard": {
    backgroundColor: "transparent",
    color: "inherit",
    boxShadow: "none",
    marginTop: "20%",
    marginBottom: "20%",
  },
  "& .leftGridCardHeader": {
    display: "flex",
    justifyContent: "center",
    alignItems: "left",
    flexDirection: "column",
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1.5),
    color: "white",
    textAlign: "left",
  },
  "& .back-button": {
    padding: theme.spacing(0),
    margin: theme.spacing(1),
    color: "white",
    size: "large",
  },
  "& .backBox": {
    display: "flex",
  },
  "& .leftGridTitle": {
    cursor: "pointer",
  },
  "& .leftGridSubtitle": {
    fontSize: theme.typography.pxToRem(14),
    marginTop: theme.spacing(2),
    letterSpacing: "0.5px",
    lineHeight: theme.spacing(3),
  },
}));

export default LeftGridTemplateStyles;